/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Audit Service API
 * Read access to the platform audit trail.
 *
 * Every audited action across every domain lands here as one record. Records
 * are **append-only** — there is no write API; the only way in is by
 * publishing `audit.<aggregate_type>.recorded`.
 *
 * **Pagination is keyset, never offset.** A late-arriving event with an older
 * `occurredAt` inserts into the middle of an offset-paginated result set,
 * which silently duplicates or skips rows as a client scrolls — a live bug in
 * the equipment endpoint this replaces. Pass the `nextCursor` from the previous
 * page back as `cursor`.
 *
 * The cursor is **opaque**: clients must echo it, not construct it. It encodes
 * the `(occurredAt, id)` keyset today, and keeping that private means the
 * ordering key can change without breaking every caller.
 *
 * **Authorisation** is a viewer floor plus site-claim filtering. audit-svc
 * holds no domain tables, so it authorises from the record's own denormalised
 * `siteId`; records outside the caller's claims are filtered out in the query
 * rather than after it, so paging stays correct. Admin sees every site.
 *
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditPageDTO,
  ForbiddenResponse,
  GetActorAuditTimelineParams,
  GetAuditTimelineParams,
  GetSiteAuditTimelineParams,
  UnauthorizedResponse
} from './model';

import { customFetch } from './custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAuditTimelineUrl = (aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit/${aggregateType}/${aggregateId}/timeline?${stringifiedParams}` : `/api/audit/${aggregateType}/${aggregateId}/timeline`
}

/**
 * Every recorded action for one aggregate, newest first.
 *
 * Unlike the equipment history it replaces, this **still resolves after
 * the aggregate is deleted** — the audit trail outlives what it describes,
 * which is the question an audit trail most needs to answer.
 * @summary Audit timeline for one aggregate
 */
export const getAuditTimeline = async (aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: RequestInit): Promise<AuditPageDTO> => {

  return customFetch<AuditPageDTO>(getGetAuditTimelineUrl(aggregateType,aggregateId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuditTimelineInfiniteQueryKey = (aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams,) => {
    return [
    'infinite', `/api/audit/${aggregateType}/${aggregateId}/timeline`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetAuditTimelineQueryKey = (aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams,) => {
    return [
    `/api/audit/${aggregateType}/${aggregateId}/timeline`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAuditTimelineInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAuditTimeline>>, GetAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData, QueryKey, GetAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditTimelineInfiniteQueryKey(aggregateType,aggregateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditTimeline>>, QueryKey, GetAuditTimelineParams['cursor']> = ({ signal, pageParam }) => getAuditTimeline(aggregateType,aggregateId,{...params, 'cursor': pageParam ?? params?.['cursor']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: aggregateType !== null && aggregateType !== undefined && aggregateId !== null && aggregateId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData, QueryKey, GetAuditTimelineParams['cursor']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditTimelineInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditTimeline>>>
export type GetAuditTimelineInfiniteQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAuditTimeline>>, GetAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 aggregateType: string,
    aggregateId: string,
    params: undefined |  GetAuditTimelineParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData, QueryKey, GetAuditTimelineParams['cursor']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getAuditTimeline>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAuditTimeline>>, GetAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData, QueryKey, GetAuditTimelineParams['cursor']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getAuditTimeline>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAuditTimeline>>, GetAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData, QueryKey, GetAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audit timeline for one aggregate
 */

export function useGetAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAuditTimeline>>, GetAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData, QueryKey, GetAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditTimelineInfiniteQueryOptions(aggregateType,aggregateId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuditTimelineQueryOptions = <TData = Awaited<ReturnType<typeof getAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuditTimelineQueryKey(aggregateType,aggregateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditTimeline>>> = ({ signal }) => getAuditTimeline(aggregateType,aggregateId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: aggregateType !== null && aggregateType !== undefined && aggregateId !== null && aggregateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuditTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof getAuditTimeline>>>
export type GetAuditTimelineQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetAuditTimeline<TData = Awaited<ReturnType<typeof getAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 aggregateType: string,
    aggregateId: string,
    params: undefined |  GetAuditTimelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getAuditTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditTimeline<TData = Awaited<ReturnType<typeof getAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getAuditTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuditTimeline<TData = Awaited<ReturnType<typeof getAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audit timeline for one aggregate
 */

export function useGetAuditTimeline<TData = Awaited<ReturnType<typeof getAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 aggregateType: string,
    aggregateId: string,
    params?: GetAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuditTimelineQueryOptions(aggregateType,aggregateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSiteAuditTimelineUrl = (siteId: string,
    params?: GetSiteAuditTimelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit/sites/${siteId}/timeline?${stringifiedParams}` : `/api/audit/sites/${siteId}/timeline`
}

/**
 * Every recorded action scoped to one site, newest first — the shape a
 * compliance export needs. Requires a claim on that site; admin bypasses.
 * @summary Audit timeline for one site
 */
export const getSiteAuditTimeline = async (siteId: string,
    params?: GetSiteAuditTimelineParams, options?: RequestInit): Promise<AuditPageDTO> => {

  return customFetch<AuditPageDTO>(getGetSiteAuditTimelineUrl(siteId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSiteAuditTimelineInfiniteQueryKey = (siteId: string,
    params?: GetSiteAuditTimelineParams,) => {
    return [
    'infinite', `/api/audit/sites/${siteId}/timeline`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetSiteAuditTimelineQueryKey = (siteId: string,
    params?: GetSiteAuditTimelineParams,) => {
    return [
    `/api/audit/sites/${siteId}/timeline`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSiteAuditTimelineInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getSiteAuditTimeline>>, GetSiteAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(siteId: string,
    params?: GetSiteAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData, QueryKey, GetSiteAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSiteAuditTimelineInfiniteQueryKey(siteId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSiteAuditTimeline>>, QueryKey, GetSiteAuditTimelineParams['cursor']> = ({ signal, pageParam }) => getSiteAuditTimeline(siteId,{...params, 'cursor': pageParam ?? params?.['cursor']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: siteId !== null && siteId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData, QueryKey, GetSiteAuditTimelineParams['cursor']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSiteAuditTimelineInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSiteAuditTimeline>>>
export type GetSiteAuditTimelineInfiniteQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetSiteAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSiteAuditTimeline>>, GetSiteAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 siteId: string,
    params: undefined |  GetSiteAuditTimelineParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData, QueryKey, GetSiteAuditTimelineParams['cursor']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSiteAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getSiteAuditTimeline>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSiteAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSiteAuditTimeline>>, GetSiteAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 siteId: string,
    params?: GetSiteAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData, QueryKey, GetSiteAuditTimelineParams['cursor']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSiteAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getSiteAuditTimeline>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSiteAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSiteAuditTimeline>>, GetSiteAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 siteId: string,
    params?: GetSiteAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData, QueryKey, GetSiteAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audit timeline for one site
 */

export function useGetSiteAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSiteAuditTimeline>>, GetSiteAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 siteId: string,
    params?: GetSiteAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData, QueryKey, GetSiteAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSiteAuditTimelineInfiniteQueryOptions(siteId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSiteAuditTimelineQueryOptions = <TData = Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(siteId: string,
    params?: GetSiteAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSiteAuditTimelineQueryKey(siteId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSiteAuditTimeline>>> = ({ signal }) => getSiteAuditTimeline(siteId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSiteAuditTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof getSiteAuditTimeline>>>
export type GetSiteAuditTimelineQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetSiteAuditTimeline<TData = Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 siteId: string,
    params: undefined |  GetSiteAuditTimelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSiteAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getSiteAuditTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSiteAuditTimeline<TData = Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 siteId: string,
    params?: GetSiteAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSiteAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getSiteAuditTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSiteAuditTimeline<TData = Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 siteId: string,
    params?: GetSiteAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audit timeline for one site
 */

export function useGetSiteAuditTimeline<TData = Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 siteId: string,
    params?: GetSiteAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSiteAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSiteAuditTimelineQueryOptions(siteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetActorAuditTimelineUrl = (actorId: string,
    params?: GetActorAuditTimelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/audit/actors/${actorId}/timeline?${stringifiedParams}` : `/api/audit/actors/${actorId}/timeline`
}

/**
 * Everything one person or service did, newest first, filtered to the
 * caller's site claims. Manager floor: "what has this person been doing"
 * is a supervisory question, not a general read.
 * @summary Audit timeline for one actor
 */
export const getActorAuditTimeline = async (actorId: string,
    params?: GetActorAuditTimelineParams, options?: RequestInit): Promise<AuditPageDTO> => {

  return customFetch<AuditPageDTO>(getGetActorAuditTimelineUrl(actorId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActorAuditTimelineInfiniteQueryKey = (actorId: string,
    params?: GetActorAuditTimelineParams,) => {
    return [
    'infinite', `/api/audit/actors/${actorId}/timeline`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetActorAuditTimelineQueryKey = (actorId: string,
    params?: GetActorAuditTimelineParams,) => {
    return [
    `/api/audit/actors/${actorId}/timeline`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActorAuditTimelineInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActorAuditTimeline>>, GetActorAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(actorId: string,
    params?: GetActorAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData, QueryKey, GetActorAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActorAuditTimelineInfiniteQueryKey(actorId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActorAuditTimeline>>, QueryKey, GetActorAuditTimelineParams['cursor']> = ({ signal, pageParam }) => getActorAuditTimeline(actorId,{...params, 'cursor': pageParam ?? params?.['cursor']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: actorId !== null && actorId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData, QueryKey, GetActorAuditTimelineParams['cursor']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActorAuditTimelineInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActorAuditTimeline>>>
export type GetActorAuditTimelineInfiniteQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetActorAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActorAuditTimeline>>, GetActorAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 actorId: string,
    params: undefined |  GetActorAuditTimelineParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData, QueryKey, GetActorAuditTimelineParams['cursor']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActorAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getActorAuditTimeline>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActorAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActorAuditTimeline>>, GetActorAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 actorId: string,
    params?: GetActorAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData, QueryKey, GetActorAuditTimelineParams['cursor']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActorAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getActorAuditTimeline>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActorAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActorAuditTimeline>>, GetActorAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 actorId: string,
    params?: GetActorAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData, QueryKey, GetActorAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audit timeline for one actor
 */

export function useGetActorAuditTimelineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActorAuditTimeline>>, GetActorAuditTimelineParams['cursor']>, TError = UnauthorizedResponse | ForbiddenResponse>(
 actorId: string,
    params?: GetActorAuditTimelineParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData, QueryKey, GetActorAuditTimelineParams['cursor']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActorAuditTimelineInfiniteQueryOptions(actorId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActorAuditTimelineQueryOptions = <TData = Awaited<ReturnType<typeof getActorAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(actorId: string,
    params?: GetActorAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActorAuditTimelineQueryKey(actorId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActorAuditTimeline>>> = ({ signal }) => getActorAuditTimeline(actorId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: actorId !== null && actorId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActorAuditTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof getActorAuditTimeline>>>
export type GetActorAuditTimelineQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetActorAuditTimeline<TData = Awaited<ReturnType<typeof getActorAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 actorId: string,
    params: undefined |  GetActorAuditTimelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActorAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getActorAuditTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActorAuditTimeline<TData = Awaited<ReturnType<typeof getActorAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 actorId: string,
    params?: GetActorAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActorAuditTimeline>>,
          TError,
          Awaited<ReturnType<typeof getActorAuditTimeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActorAuditTimeline<TData = Awaited<ReturnType<typeof getActorAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 actorId: string,
    params?: GetActorAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audit timeline for one actor
 */

export function useGetActorAuditTimeline<TData = Awaited<ReturnType<typeof getActorAuditTimeline>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 actorId: string,
    params?: GetActorAuditTimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActorAuditTimeline>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActorAuditTimelineQueryOptions(actorId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







